import '././css/main.css'
import ContactFormInterpreting from './Components/ContactFormInterpreting.jsx';
import {useRtlProps} from './helpers/rtl.js'

function AppContactFormInterpreting() {
  const rtl = useRtlProps()
  return <div id="translated-app" {...rtl}><ContactFormInterpreting /></div>
}

export default AppContactFormInterpreting;
